/**
 * 발급된 다운로드 URL 의 응답 본문을 받아 즉시 사용자의 디스크로 저장한다.
 *
 * 서버가 코드 활성화 시점에 `downloadUrl` 을 함께 내려주므로 별도의 보상 요청 mutation 은
 * 두지 않는다. 컴포넌트는 redemption state 의 `downloadUrl` 을 그대로 이 함수에 넘긴다.
 *
 * **동작 방식**
 *  1. `fetch` 로 응답 본문을 받아 `Blob` 으로 변환한다.
 *  2. 동일 출처 보장을 위한 `blob:` URL 을 만들어 임시 `<a download>` 로 클릭한다.
 *  3. 사용을 마친 blob URL 은 즉시 해제(`revokeObjectURL`)한다.
 *
 * 이 방식은 서버 응답이 동일 출처가 아니거나 `Content-Disposition` 헤더를 포함하지
 * 않아도 브라우저가 새 탭을 열지 않고 곧바로 저장 다이얼로그를 띄우게 한다.
 * 단, 서버 측 `Access-Control-Allow-Origin` 이 허용되어야 cross-origin 환경에서 동작한다.
 *
 * @param url - 서버가 내려준 보상 다운로드 URL
 * @param filename - 저장 시 사용할 파일명 (기본값 `reward.png`)
 * @throws 네트워크 실패 또는 2xx 가 아닌 응답일 때 `Error`
 */
export async function triggerDownload(
  url: string,
  filename = 'reward.png',
): Promise<void> {
  const response = await fetch(url, { credentials: 'omit' });
  if (!response.ok) {
    throw new Error(`다운로드에 실패했어요. (HTTP ${String(response.status)})`);
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  try {
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = filename;
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    link.remove();
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}
